import { useMemo } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { chartColors } from './chartColors';

const BUCKET_LABELS: Record<string, string> = {
  '0_20': '0-20',
  '21_40': '21-40',
  '41_60': '41-60',
  '61_80': '61-80',
  '81_100': '81-100',
};

const BUCKET_ORDER = ['0_20', '21_40', '41_60', '61_80', '81_100'];

interface ScoreDistributionProps {
  data: Record<string, number>;
}

export function ScoreDistribution({ data }: ScoreDistributionProps) {
  const chartData = useMemo(
    () =>
      BUCKET_ORDER.map((key) => ({
        range: BUCKET_LABELS[key] || key,
        count: data[key] || 0,
      })),
    [data]
  );

  const hasData = chartData.some((d) => d.count > 0);
  if (!hasData) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="range" fontSize={12} />
        <YAxis allowDecimals={false} fontSize={12} />
        <Tooltip />
        <Bar dataKey="count" fill={chartColors.series} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
